/*
 * Sunnbloom "Me" FAB
 * ---------------------------------------------------------------------------
 * Open/close only. Every count inside the menu is maintained by code that
 * already existed — updateCount() in sunnbloom-cart.js and paint() in
 * sunnbloom-wishlist.js — via the data hooks documented in the snippet. This
 * file deliberately knows nothing about carts or wishlists.
 *
 * Standalone rather than folded into sunnbloom.js because the FAB renders
 * whenever ordering OR the wishlist is on, while sunnbloom-cart.js only loads
 * when ordering is on. Depending on that file would leave the menu dead on a
 * wishlist-only store.
 */
(function () {
  'use strict';

  function root() {
    return document.querySelector('[data-sb-me-fab]');
  }

  function isOpen(fab) {
    var menu = fab.querySelector('[data-sb-me-menu]');
    return menu && !menu.hidden;
  }

  function open(fab) {
    var menu = fab.querySelector('[data-sb-me-menu]');
    var toggle = fab.querySelector('[data-sb-me-toggle]');
    if (!menu) return;

    menu.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    /* Stagger the rows. Done here rather than in Liquid because the Bag row
       may be hidden when the bag is empty, and a server-rendered index would
       leave a gap in the sequence. */
    var visible = Array.prototype.filter.call(
      menu.querySelectorAll('.sb-me-fab__item'),
      function (item) {
        return !item.hidden;
      }
    );
    /* Bottom row animates first: it is nearest the thumb. */
    visible.reverse().forEach(function (item, index) {
      item.style.setProperty('--row', index);
    });
  }

  function close(fab, refocus) {
    var menu = fab.querySelector('[data-sb-me-menu]');
    var toggle = fab.querySelector('[data-sb-me-toggle]');
    if (!menu || menu.hidden) return;

    menu.hidden = true;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (refocus) toggle.focus();
    }
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var fab = root();
    if (!fab) return;

    if (evt.target.closest('[data-sb-me-toggle]')) {
      evt.preventDefault();
      if (isOpen(fab)) {
        close(fab, false);
      } else {
        open(fab);
      }
      return;
    }

    /* A tap on the Bag row opens the cart drawer via sunnbloom-cart.js. Close
       the menu too, or it sits on top of the drawer it just opened. */
    if (evt.target.closest('.sb-me-fab__item')) {
      close(fab, false);
      return;
    }

    if (!evt.target.closest('[data-sb-me-fab]')) close(fab, false);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var fab = root();
    if (fab) close(fab, true);
  });
})();
